import { useTenantStore } from "../../stores/tenant/use-tenant-store";


const SimuladorPage = () => {
  const { partnerId } = useTenantStore();

  return (
    <main className="flex items-center justify-center min-h-dvh w-screen">
      <iframe
        src={`https://simulador.ivienergia.com/?parceiroId=${partnerId}`}
        title="Simulador IVI Energia"
        className="w-full min-h-dvh"
        allowFullScreen={true}
      ></iframe>
    </main>
  );
};

export { SimuladorPage };